import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, TextField, Select, InputLabel, FormControl, MenuItem } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import CityPicker from "src/components/CityPicker";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import MerchantInfo from "src/components/common/MerchantInfo";

const TABLE_HEAD = [
  // { id: "mid", label: "ID", alignRight: false },
  { id: "user", label: "用户", alignRight: false },
  { id: "total", label: "消费券抵扣", alignRight: false },
  // { id: "monthly", label: "月消费券", alignRight: false },
  // { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 },
];

const sortList = [
  { label: "本年消费券抵扣", value: "year" },
  { label: "上月消费券抵扣", value: "lastMonth" },
  { label: "本月消费券抵扣", value: "month" },
  { label: "上周消费券抵扣", value: "lastWeek" },
  { label: "本周消费券抵扣", value: "week" },
  { label: "昨日消费券抵扣", value: "yesterday" },
  { label: "今日消费券抵扣", value: "today" },
];

export default function BalanceStats() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [remaining, setRemaining] = useState('');
  const [remainingMer, setRemainingMer] = useState('');
  const [totalUsed, setTotalUsed] = useState('');

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    search: "",
    provinceId: null,
    cityId: null,
    districtId: null,
    createdAt: null,
    sort: "today",
    order: "DESC",
  });

  useEffect(() => {
    getItems();
    getUserTotal();
    getMerchantTotal();
    getTotalUsed();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/balance/userank",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  async function getUserTotal() {
    const { data } = await asyncRequest({
      path: "/finance/balance/remaining",
      data: filter,
    });

    setRemaining(data);
  }

  async function getMerchantTotal() {
    const { data } = await asyncRequest({
      path: "/finance/balance/remainingMer",
      data: filter,
    });

    setRemainingMer(data);
  }

  

  async function getTotalUsed() {
    const { data } = await asyncRequest({
      path: "/finance/balance/totalUsed",
      data: filter,
    });

    setTotalUsed(data);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/merchant/edit/${row.mid}`, { state: row });
    }
  };

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="消费券统计">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              消费券统计
            </Typography>
          </Stack>

          <Card>
            <ListToolbar
              filterName={filter.search}
              onFilterName={handleFilterByName}
              onRefresh={() => {
                getItems();
                getUserTotal();
              }}
              onReset={() => {
                setFilter({
                  page: 0,
                  size: 20,
                  search: "",
                  provinceId: null,
                  cityId: null,
                  districtId: null,
                  createdAt: null,
                  sort: "today",
                  order: "DESC",
                })
              }}
            >
              <MyDateRangePicker
                value={filter.createdAt}
                onChange={(val) => {
                  setFilter({
                    ...filter,
                    createdAt: val,
                  });
                }}
              />

              <FormControl size="small">
                <InputLabel id="demo-simple-select-label">检索方式</InputLabel>
                <Select
                  label="检索方式"
                  value={filter.sort}
                  onChange={(e) => {
                    setFilter({
                      ...filter,
                      sort: e.target.value,
                    });
                  }}
                  style={{ width: 250 }}
                >
                  {sortList.map((item, idx) => (
                    <MenuItem key={idx} value={item.value} name={item}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TableRow>
                    <TableCell>
                      <Stack>
                        <Typography>用户剩余消费券：{remaining}</Typography>
                        <Typography>商户剩余消费券：{remainingMer}</Typography>
                        <Typography>消费券抵用数额：{totalUsed}</Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                  <ListHead headLabel={TABLE_HEAD} />
                  <TableBody>
                    {items.map((row) => {
                      const { mid, totalDeduction, user, realname } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, mid)}
                            />
                          </TableCell> */}
                          {/* <TableCell align="left">{mid}</TableCell> */}
                          <TableCell align="left">
                            <UserInfo {...user} />
                          </TableCell>
                          <TableCell align="left">{totalDeduction}</TableCell>
                          {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}
                          <TableCell align="right"></TableCell>
                        </TableRow>
                      );
                    })}

                    {/* <TableRow>
                      <TableCell>
                        <Stack>
                          <Typography>年度消费券：{dailyTotal.yearly}元</Typography>
                          <Typography>本度消费券：{dailyTotal.monthly}元</Typography>
                          <Typography>昨日消费券：{dailyTotal.yesterday}元</Typography>
                          <Typography>今日消费券：{dailyTotal.today}元</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow> */}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        </Container>
      </Page>
    </>
  );
}
